class MainGallery extends HTMLElement {
  connectedCallback() {
    this.mainGallery = this.querySelector('.main-gallery');
    this.subGallery = this.querySelector('.sub-gallery');
    this.imageGallery = this.querySelector('.image-gallery');

    this.subTitleEl = this.subGallery.querySelector('.title-wrapper .title');
    this.imageTitleEl = this.imageGallery.querySelector('.title-wrapper .title');

    // Level 1 → Level 2: click a main gallery card
    this.mainGallery.querySelectorAll('[data-mg-id]').forEach((el) => {
      el.addEventListener('click', () => this.showSubGallery(el));
    });

    // Level 2 → Level 3: click a sub gallery card
    this.subGallery.querySelectorAll('[data-gallery-id]').forEach((el) => {
      el.addEventListener('click', () => this.showImageGallery(el));
    });

    // Back buttons
    this.querySelectorAll('[data-back-to]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-back-to');
        if (target === 'main') this.showMainGallery();
        else if (target === 'sub') this.showSubGalleryFromBack();
      });
    });

    // Download buttons
    this.imageGallery.querySelectorAll('.gallery-item__download-button').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.downloadImage(btn);
      });
    });
  }

  async downloadImage(btn) {
    const url = btn.getAttribute('data-image-url');
    const filename = btn.getAttribute('data-filename') || 'image.jpg';

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.error('Gallery download failed:', err);
    }
  }

  showSubGallery(el) {
    const mgId = el.getAttribute('data-mg-id');
    const label = el.getAttribute('data-title');
    this.activeMgId = mgId;

    window.scrollTo({ top: 0, behavior: 'instant' });

    if (this.subTitleEl) {
      this.subTitleEl.innerHTML = `<em class="color-${this.subTitleEl.getAttribute('data-color-scheme')}">${label}</em>`;
    }

    this.subGallery.querySelectorAll('[data-mg-group]').forEach((group) => {
      group.classList.toggle('hidden', group.getAttribute('data-mg-group') !== mgId);
    });

    this.mainGallery.classList.add('hidden');
    this.imageGallery.classList.add('hidden');
    this.subGallery.classList.remove('hidden');
  }

  showImageGallery(el) {
    const galleryId = el.getAttribute('data-gallery-id');
    const label = el.getAttribute('data-title');

    window.scrollTo({ top: 0, behavior: 'instant' });

    if (this.imageTitleEl) {
      this.imageTitleEl.innerHTML = `<em class="color-${this.imageTitleEl.getAttribute('data-color-scheme')}">${label}</em>`;
    }

    this.imageGallery.querySelectorAll('[data-gallery-group]').forEach((group) => {
      group.classList.toggle('hidden', group.getAttribute('data-gallery-group') !== galleryId);
    });

    this.mainGallery.classList.add('hidden');
    this.subGallery.classList.add('hidden');
    this.imageGallery.classList.remove('hidden');
  }

  showMainGallery() {
    window.scrollTo({ top: 0, behavior: 'instant' });
    this.subGallery.classList.add('hidden');
    this.imageGallery.classList.add('hidden');
    this.mainGallery.classList.remove('hidden');
    this.activeMgId = null;
  }

  showSubGalleryFromBack() {
    window.scrollTo({ top: 0, behavior: 'instant' });
    this.imageGallery.classList.add('hidden');
    this.subGallery.classList.remove('hidden');
  }
}

customElements.define('main-gallery', MainGallery);
